export const FEEDBACK_FORM_URL =
  'https://docs.google.com/forms/d/1AEHIjw1kETN5cOi1pnFR-3xlwxEU9X0rqaZnFGus9Is/edit';
export const API_DOCUMENTATION_URL =
  'https://developer.fareharbor.com/api/external/v1/';
